module.exports = __webpack_public_path__ + "static/img/user.5b46d222.svg";